import React from "react"
import * as Icon1 from "react-icons/bi"
import * as Icon3 from "react-icons/hi2"
import * as Icon2 from "react-icons/io5"

const contactDetails = [
  {
    icon: "HiChatBubbleLeftRight",
    heading: "Chat on us",
    description: "Our friendly team is here to help.",
    details: "info@CourseCatalyst.com",
  },
  {
    icon: "BiWorld",
    heading: "Visit us",
    description: "Come and say hello at our office HQ.",
    details:
      "Course Catalyst Office, Delhi-110041",
  },
  {
    icon: "IoCall",
    heading: "Call us",
    description: "Mon - Fri From 9am to 7pm",
    details: "011 2457843",
  },
]

const ContactDetails = () => {
  return (
    <div className="flex flex-col gap-6 rounded-xl bg-pure-greys-150 p-4 lg:p-6">
      {contactDetails.map((ele, i) => {
        let Icon = Icon1[ele.icon] || Icon2[ele.icon] || Icon3[ele.icon]
        return (
          <div
            className="flex flex-col gap-[2px] p-3 text-sm text-richblack-800"
            key={i}
          >
            <div className="flex flex-row items-center gap-3">
              <Icon size={25} className='text-pink-50' />
              <h1 className="text-lg font-semibold text-richblack-5">
                {ele?.heading}
              </h1>
            </div>
            <p className="font-medium">{ele?.description}</p>
            <p className="font-semibold text-richblack-400">{ele?.details}</p>
          </div>
        )
      })}
    </div>
  )
}

export default ContactDetails
